<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods:{
    
  },
  created(){
    // this.getCustomerPhone();
  }
}
</script>

<style lang="less">
::-webkit-scrollbar{
  display:none;
}
#app{
  
    background:#F5F5F5;
}

body{
  /deep/ .el-dialog{
    border-radius: 16px;
  }
  /deep/ .el-dialog__header{
    display: none;
  }
  /deep/ .el-dialog__body{
    padding:30px 25px 20px 25px;
  }
   .el-input__inner::placeholder {
        color: #A6AEC1;
    }
     /* 谷歌 */
    .el-input__inner::-webkit-input-placeholder {
        color: #A6AEC1;
    }
     /* 火狐 */
   .el-input__inner:-moz-placeholder {
        color: #A6AEC1;
    }
     /*ie*/
   .el-input__inner:-ms-input-placeholder {
        color: #A6AEC1;
    }
        
    /deep/ .el-dropdown-menu{
      top:68px!important;
    }
}
.amap-sug-result{
  z-index: 10000;
}
.common{
    &_pagination{
          padding-top:30px;
          display: flex;
          align-items: center;
          font-size: 12px;
          color:#000000;
          /deep/ .el-pager li,/deep/ .btn-next, /deep/ .btn-prev{
              min-width: 36px;
              height: 36px;
              padding-top:4px;
              margin: 0 4px;
          }
          /deep/ .btn-prev{
              margin-left: 0;
          }
          &_right{
              display: flex;
              align-items: baseline;
              &_num{
                  span{
                      color:#3D7FFF;
                  }
                  
              }
              &_input{
                  margin:0 10px;
              }
              &_btn{
                  /deep/ .el-button{
                      background:#F0F2F5;
                      height: 36px;
                      border:1px solid #D7DBE0;
                      font-size: 14px;
                      color:#333;
                  }
                  /deep/ .el-button:hover{
                      color: #409EFF;
                      border-color: #c6e2ff;
                      background-color: #ecf5ff;
                  }
                  
              }
          }
      }
}

.null{
    text-align: center;
    &_img{
        margin-top: 100px;
        width:303px;
        height: 255px;
    }
    &_title{
        margin-top:13px;
        font-size: 18px;
        color:#333333;
        font-weight: 500;
    }
    /deep/ .el-button{
      margin-top:25px;
      width: 152px;
      height: 40px;
      line-height: 40px;
      font-size: 18px;
      padding: 0;
    }
}

</style>



// WEBPACK FOOTER //
// src/App.vue